// apiFetch.ts
import * as React from "react";
import { useAuth } from "../auth";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";

export function useApiFetch() {
  const { accessToken, setAccessToken } = useAuth();
  const REFRESH_URL = `${API_BASE_URL}/Auth/Refresh`; // match your server route/casing
  const navigate = useNavigate();

  const apiFetch = React.useCallback(
    async (input: RequestInfo | URL, init: RequestInit = {}) => {
      // attach current access token
      const headers = new Headers(init.headers ?? {});
      if (accessToken) headers.set("Authorization", `Bearer ${accessToken}`);
      const opts: RequestInit = { ...init, headers, credentials: "include" };

      let res = await fetch(API_BASE_URL +  input, opts);
      if (res.status !== 401) 
        return res;


      //const t = sessionStorage.getItem("refreshToken");

      // avoid refresh loop
      const urlStr =
        typeof input === "string" ? input : (input as URL).toString();
      if (urlStr.includes("/Auth/Refresh")) return res;

      // try refresh via HttpOnly cookie
      const r = await fetch(REFRESH_URL, {
        method: "POST",
       // body: JSON.stringify(t),
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      if (!r.ok) 
        {
          setAccessToken(null);

          navigate("/");
          return res;
        }

      //const { accessToken: newToken, refreshToken: newRefreshToken } = await r.json();
      const { accessToken: newToken} = await r.json();
      if (!newToken) return res;

      // store and retry original with the new token
      setAccessToken(newToken);
      //sessionStorage.setItem("refreshToken", newRefreshToken);

      const retryHeaders = new Headers(init.headers ?? {});
      retryHeaders.set("Authorization", `Bearer ${newToken}`);
      return fetch(API_BASE_URL + input, {
        ...init,
        headers: retryHeaders,
        credentials: "include",
      });
    },
    [accessToken, setAccessToken, REFRESH_URL]
  );

  return apiFetch;
}
